import React, { useContext, useEffect, useState } from 'react';
import { Header } from './header/Header';
import { Footer } from './footer/Footer';
import styled from '@emotion/styled';
import useFetch from './hooks/useFetch';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'qs';
import { Preview } from './preview/Preview';
import { TagInfo } from './TagInfo';
import {
  checkIfSupportedPreset,
  ErrorModel,
  tagNotFoundError,
} from './error/error';
import {Tag} from "./model/Tag";
import {inferTag} from "./services/TagInferringService";

const isNotEmpty = (obj) => {
  return Object.keys(obj).length > 0
}

const buildPreviewUrl = async (location, params, tag: Tag) => {
  let { device = 'firetv' } = params;
  const query = qs.parse(location.search.replace('?',''));
  const iframeQuery = qs.stringify({
    version: query.version ?? 'latest',
    'preview-as': device,
    autoplay: false,
    smartLinkParams: query.smartLinkParams ?? "",
    'ivc': tag.ivcQueryParams ?? query.ivc ?? ""
  });
  return `/preview/${tag.type}/${tag.tagId}/${query.preset ?? ''}?${iframeQuery}`;
};


const buildConfigUrl = (params) => {
  const { type, tagId } = params;
  return `/demo/info/${type}/${tagId}`;
};

interface DemoContextType {
  tagInfo?: TagInfo,
  previewUrl?: string,
  error?: ErrorModel
  isExternal: boolean
}

export const DemoContext = React.createContext({} as DemoContextType);

export const Demo = () => {
  const params = useParams();
  const location = useLocation();
  const isExternal = qs.parse(location.search.replace('?', '')).external === '1';
  const [inferredTag, setInferredTag] = useState({} as Tag)
  const [previewUrl, setPreviewUrl] = useState("");
  const { data: tagInfo, error: fetchError } = useFetch(isNotEmpty(inferredTag) ? buildConfigUrl(inferredTag) : "");
  const [error, setError] = useState<ErrorModel>();

  useEffect(() => {
    const getInferredTag = async () => {
      const tag = await inferTag(params)
      setInferredTag(tag)
    }
    getInferredTag()
  }, [params])

  useEffect(() => {
    setError(tagInfo ? checkIfSupportedPreset(tagInfo) : undefined);
  }, [tagInfo]);

  useEffect(() => {
    if (isNotEmpty(inferredTag)) {
      const getPreviewUrl = async () => {
        const builtUrl = await buildPreviewUrl(location, params, inferredTag)
        setPreviewUrl(builtUrl);
      }
      getPreviewUrl()
    }
  }, [location, params, inferredTag]);

  useEffect(() => {
    !!fetchError && setError(tagNotFoundError);
  }, [fetchError]);

  return <DemoContainer >
    <DemoContext.Provider value={{ tagInfo, previewUrl, error, isExternal }}>
      <DemoWrapper/>
    </DemoContext.Provider>
  </DemoContainer>;
};

const DemoWrapper = () => {
  const {isExternal} = useContext(DemoContext);
  return <>
    <Header/>
    <Preview/>
    {!isExternal && <Footer/>}
  </>;
};

const DemoContainer = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  flex-flow: column;
  justify-content: space-between;
  flex: 1 1 auto;
`;
